import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ArchivedListDataSource } from '@go-modules/services/archive';

@Component({
	selector: 'archive-zero-state',
	templateUrl: './archive-zero-state.component.html',
	styleUrls: ['./archive-zero-state.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ArchiveZeroStateComponent {
	constructor (public archivedListDataSource: ArchivedListDataSource) {}
}
